export default __webpack_public_path__ + "static/media/StatusWarningIcon.7ff5439c.svg";